import { EmailTemplate } from "../../types/EmailTemplate";

export const TemplateEvent: EmailTemplate = {
  id: "event",
  name: "Invitation événement",
  description: "Invitation avec date, heure et lieu mis en évidence",
  templateFile: "event",
  previewData: {
    heroImage: "https://via.placeholder.com/600x200/1a2a6c/ffffff?text=EVENEMENT",
    title: "Vous êtes invité(e) !",
    eventDate: "Samedi 15 mars 2026",
    eventTime: "14h00 - 17h00 (HE)",
    eventLocation: "Montréal, QC — En ligne via Zoom",
    message:
      "Rejoignez-nous pour découvrir les nouveautés IZI LIFE PAY et échanger avec notre équipe.<br><br>Places limitées — confirmez votre participation.",
    ctaText: "Confirmer ma présence",
    ctaUrl: "https://izilifepay.com/evenement",
  },
  fields: [
    { name: "heroImage", label: "Bannière", type: "image", required: false },
    {
      name: "title",
      label: "Titre de l'événement",
      type: "text",
      required: true,
      defaultValue: "Vous êtes invité(e) !",
    },
    {
      name: "eventDate",
      label: "Date",
      type: "text",
      required: true,
      placeholder: "Ex: Samedi 15 mars 2026",
    },
    {
      name: "eventTime",
      label: "Heure",
      type: "text",
      required: false,
      placeholder: "Ex: 14h00 - 17h00 (HE)",
    },
    {
      name: "eventLocation",
      label: "Lieu",
      type: "text",
      required: false,
      placeholder: "Ex: Montréal ou lien Zoom",
    },
    {
      name: "message",
      label: "Message",
      type: "textarea",
      required: true,
      placeholder: "Description de l'événement...",
    },
    {
      name: "ctaText",
      label: "Texte du bouton",
      type: "text",
      required: true,
      defaultValue: "Confirmer ma présence",
    },
    {
      name: "ctaUrl",
      label: "Lien du bouton",
      type: "url",
      required: true,
      defaultValue: "https://izilifepay.com",
    },
  ],
};
